import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ListItem.module.scss';
import TagImage from './TagImage';
import { TagOption } from './TagOption';
import clsx from 'clsx';

interface ListItemProps<T> {
    tag: TagOption<T>;
    className?: string;
    onClick?: () => void;
}

export const ListItem = <T,>(props: ListItemProps<T>) => {
    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={props.onClick}
        >
            {props.tag.image && (
                <TagImage
                    src={props.tag.image}
                    className={styles.image}
                />
            )}
            {props.tag.image === undefined && props.tag.icon && (
                <FontAwesomeIcon
                    icon={props.tag.icon}
                    className={styles.icon}
                />
            )}
            <span className={styles.name}>{props.tag.name}</span>
        </div>
    );
};

export default ListItem;
